import { render, staticRenderFns } from "./SignatureTimeDisplay.vue?vue&type=template&id=08a7334e&scoped=true&"
import script from "./SignatureTimeDisplay.vue?vue&type=script&lang=js&"
export * from "./SignatureTimeDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SignatureTimeDisplay.vue?vue&type=style&index=0&id=08a7334e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a7334e",
  null
  
)

export default component.exports